module.exports = __webpack_public_path__ + "img/block6.4a3fc85a.png";